import { Theme, ThemeUICSSObject } from 'theme-ui';
import { focusOutline } from '../../../../util';

const mobx: (theme: Theme) => ThemeUICSSObject = (theme) => {
  return {
    variant: 'layout.common.trees.primary',
    overflow: 'auto',
    '[role="treeitem"]': {
      '&[aria-expanded="false"] ul': {
        display: 'none',
      },

      '&[aria-selected="true"] > .mobxtree__node__label__wrapper':
        theme.palette.getOneState(
          { backgroundColor: 'palette.background.paper' },
          'selected',
        ),

      background: 'transparent',
    },

    '&[role="tree"].mobxtree :focus': {
      outline: 'none',

      '& > .mobxtree__node__label__wrapper': focusOutline,
    },
    '&[role="tree"].mobxtree .mobx__node__label__icon:focus': focusOutline,

    '.mobxtree__children__group': {
      p: 0,
      m: 0,
    },

    '.mobxtree__node__label': {
      alignItems: 'center',
      display: 'flex',
      flexGrow: 1,
      flexShrink: 1,
      gap: 3,

      '.mobxtree__node__label__renderer': {},
    },

    '.mobxtree__node__label__icons': {
      display: 'flex',
      flexShrink: 0,
      gap: 3,
    },

    '.mobxtree__node__label__wrapper': {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'nowrap',
      gap: 3,
      wordBreak: 'break-all',

      button: {
        cursor: 'pointer',

        '&:hover': {
          textDecoration: 'underline',
        },

        span: {
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
        },
      },

      '&:hover': theme.palette.getOneState(
        { backgroundColor: 'palette.background.paper' },
        'hover',
      ),
    },

    '.mobxtree__node__expander, .icon__wrapper': {
      display: 'inline-flex',
      flexShrink: 0,

      'svg.mobxtree__node__expandIcon': {
        color: 'palette.text.primary',
      },
    },

    '.spacer': {
      alignSelf: 'stretch',
      borderLeft: '1px dotted',
      borderLeftColor: 'palette.border.section',
      flexShrink: 0,
      pointerEvents: 'none',
      transform: 'translateX(9px)',
      width: '20px',
    },

    '.tree__node__icon': {
      height: '20px',
      padding: '2px',
      width: '20px',
    },
  };
};

export default mobx;
